// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.secondary-btn {
  color: var(--btn-text-color) !important;
  font-size: 12px !important;
  font-weight: 500;
  background-color: var(--btn-background-color) !important;
  margin: 0 5px;
  font-family: "ABBVoice-medium" !important;
  border-color: var(--btn-border-color) !important;
}

.disabled-btn {
  color: rgba(31, 31, 31, 0.5) !important;
  font-size: 12px !important;
  font-weight: 500;
  background-color: #dbdbdb !important;
  margin: 0 5px;
  font-family: "ABBVoice-medium" !important;
  border-color: #dbdbdb !important;
}

.secondary-btn:hover {
  color: #1f1f1f !important;
  font-size: 12px !important;
  font-weight: 500;
  margin: 0 5px;
  font-family: "ABBVoice-medium" !important;
  border-radius: 16px;
  border: 2px solid rgba(0, 0, 0, 0.24) !important;
  background: rgba(0, 0, 0, 0.12) !important;
}

.disabled-btn:hover {
  color: rgba(31, 31, 31, 0.5) !important;
  font-size: 12px !important;
  font-weight: 500;
  background-color: #dbdbdb !important;
  margin: 0 5px;
  font-family: "ABBVoice-medium" !important;
  border-color: #dbdbdb !important;
}

.btn-submit {
  background-color: #3366ff;
  border: 2px solid #3366ff;
  color: white;
  cursor: pointer;
  font-size: 12px;
  font-family: "ABBVoice";
  border-radius: 16px;
  height: 32px;
  padding: 0 16px;
  margin-top: 0;
}

.btn-submit:hover {
  background-color: #2a35ff;
  border-color: #2a35ff;
}

.btn-submit:disabled {
  background-color: #ebebeb;
  border: 2px solid #dbdbdb;
  color: rgba(31, 31, 31, 0.5);
  border-radius: 16px;
  cursor: not-allowed;
}

.ABB_CommonUX_Input__root > .ABB_CommonUX_Input__inputWrapper > .ABB_CommonUX_Input__inputElement {
  font-size: 12px !important;
}

span.ABB_CommonUX_Button__text.ABB_CommonUX_Button__hasText.ABB_CommonUX_Button__hasIcon {
  font-size: 12px;
}

.ABB_CommonUX_Icon__root > i.ABB_CommonUX_Icon__icon_abb_16 {
  font-size: 12px;
}

.ABB_CommonUX_Icon__root > i {
  line-height: 1.5;
}

.ag-theme-quartz .ag-header-cell {
  font-size: 12px !important;
}

.ag-row {
  font-size: 12px !important;
}

input[type=text] {
  font-size: 12px !important;
}

.css-15g569d-control {
  font-size: 12px !important;
}

.css-1xr93k-control,
.css-1xr93k-control:hover {
  font-size: 12px !important;
}

.ABB_CommonUX_Button__root,
.ABB_CommonUX_Dropdown__root,
.ABB_CommonUX_Checkbox__root {
  font-size: 12px !important;
  width: 100%;
}

.ag-header-cell-text {
  font-size: 12px !important;
}

.jVORrT {
  height: 14px !important;
  width: 14px !important;
}

.ewTnKk > svg {
  height: 14px !important;
  width: 14px !important;
}

.sc-gEvEer .ffXrxx {
  font-size: 12px !important;
}

:where(.css-dev-only-do-not-override-m4timi).ant-select-multiple,
:where(.css-dev-only-do-not-override-m4timi).ant-picker .ant-picker-input > input {
  font-size: 12px !important;
}

input[type=text] {
  padding-block: 0;
  padding-inline: 10px !important;
}

.page-header {
  height: 58px !important;
}
.page-header .inner-header .app-title {
  font-family: "ABBVoice-medium", sans-serif;
  display: flex !important;
  font-size: 16px !important;
  position: relative !important;
  padding-left: 0 !important;
  justify-content: center !important;
  align-items: center !important;
  margin-top: 15px !important;
  margin-left: 15px !important;
}
.page-header .inner-header .breadcrumbs {
  font-family: "ABBVoice-regular", sans-serif;
  display: flex;
  flex-direction: row;
  margin-left: 30px;
  align-items: center;
  margin-top: 16px !important;
}

.page-header .inner-header .app-title:before {
  position: absolute;
  content: "";
  width: 22px !important;
  height: 3px !important;
  background-color: #f01;
  top: -7px !important;
  left: 0px !important;
}

.MuiButtonBase-root.MuiButton-root.secondary {
  background-color: var(--btn-background-color) !important;
  color: var(--btn-text-color) !important;
  border: 1px solid var(--btn-border-color) !important;
}

.MuiButtonBase-root.MuiButton-root.secondary.disabled {
  background-color: #dbdbdb !important;
  color: #9f9f9f;
  pointer-events: none;
  cursor: not-allowed !important;
}

.ABB_CommonUX_Dialog__root > .ABB_CommonUX_Dialog__header > .ABB_CommonUX_Dialog__title {
  font-size: 14px !important;
  font-weight: 600;
}

.ABB_CommonUX_Icon__root > i.ABB_CommonUX_Icon__icon_abb_24 {
  font-size: 16px !important;
  width: 100% !important;
  display: flex;
  align-items: center;
}

.jVORrT {
  display: none !important;
}

.jiMOeR {
  position: relative;
  height: 40px !important;
}

.error-message {
  color: red;
  font-size: 14px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
}

.content-container .child-content {
  width: 100%;
}

.col-1 {
  grid-column: span 1;
}

.col-2 {
  grid-column: span 2;
}

.col-3 {
  grid-column: span 3;
}

.col-4 {
  grid-column: span 4;
}

.col-5 {
  grid-column: span 5;
}

.col-6 {
  grid-column: span 6;
}

.col-7 {
  grid-column: span 7;
}

.col-8 {
  grid-column: span 8;
}

.col-9 {
  grid-column: span 9;
}

.col-10 {
  grid-column: span 10;
}

.col-11 {
  grid-column: span 11;
}

.col-12 {
  grid-column: span 12;
}

.mr-20 {
  margin-right: 20px;
}

.gap-20 {
  gap: 20px;
}

@media screen and (max-width: 1200px) {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/common.scss"],"names":[],"mappings":"AAEA;EACE,uCAAA;EACA,0BAAA;EACA,gBAAA;EACA,wDAAA;EACA,aAAA;EACA,yCAAA;EACA,gDAAA;AADF;;AAGA;EACE,uCAAA;EACA,0BAAA;EACA,gBAAA;EACA,oCAAA;EACA,aAAA;EACA,yCAAA;EACA,gCAAA;AAAF;;AAGA;EACE,yBAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,gDAAA;EACA,0CAAA;AAAF;;AAEA;EACE,uCAAA;EACA,0BAAA;EACA,gBAAA;EACA,oCAAA;EACA,aAAA;EACA,yCAAA;EACA,gCAAA;AACF;;AACA;EACE,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAEF;;AACA;EACE,yBAAA;EACA,qBAAA;AAEF;;AACA;EACE,yBAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AAAA;EAGE,0BAAA;AACF;;AACA;EACE,eAAA;AAEF;;AAAA;EACE,eAAA;AAGF;;AADA;EACE,gBAAA;AAIF;;AAFA;EACE,0BAAA;AAKF;;AAHA;EACE,0BAAA;AAMF;;AAJA;EACE,0BAAA;AAOF;;AALA;EACE,0BAAA;AAQF;;AANA;;EAEE,0BAAA;AASF;;AAPA;;;EAGE,0BAAA;EACA,WAAA;AAUF;;AARA;EACE,0BAAA;AAWF;;AATA;EACE,uBAAA;EACA,sBAAA;AAYF;;AAVA;EACE,uBAAA;EACA,sBAAA;AAaF;;AAXA;EACE,0BAAA;AAcF;;AAZA;;EAIE,0BAAA;AAaF;;AAXA;EACE,gBAAA;EACA,+BAAA;AAcF;;AAHA;EACE,uBAAA;AAMF;AAJI;EACE,0CAAA;EACA,wBAAA;EACA,0BAAA;EACA,6BAAA;EACA,0BAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;AAMN;AAJI;EACE,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;AAMN;;AAFA;EACE,kBAAA;EACE,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;AAKJ;;AAHA;EACE,wDAAA;EACA,uCAAA;EACA,oDAAA;AAMF;;AAHA;EACE,oCAAA;EACA,cAAA;EACA,oBAAA;EACA,8BAAA;AAMF;;AAJA;EAGE,0BAAA;EACA,gBAAA;AAKF;;AAHA;EACE,0BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AAMF;;AAJA;EACE,wBAAA;AAOF;;AALA;EACE,kBAAA;EACA,uBAAA;AAQF;;AANA;EACE,UAAA;EACA,eAAA;AASF;;AANA;EACE,aAAA;EACA,sCAAA;AASF;;AAPA;EACE,WAAA;AAUF;;AAPA;EACE,mBAAA;AAUF;;AAPA;EACE,mBAAA;AAUF;;AAPA;EACE,mBAAA;AAUF;;AARA;EACE,mBAAA;AAWF;;AATA;EACE,mBAAA;AAYF;;AAVA;EACE,mBAAA;AAaF;;AAXA;EACE,mBAAA;AAcF;;AAZA;EACE,mBAAA;AAeF;;AAbA;EACE,mBAAA;AAgBF;;AAdA;EACE,oBAAA;AAiBF;;AAfA;EACE,oBAAA;AAkBF;;AAhBA;EACE,oBAAA;AAmBF;;AAhBA;EACE,kBAAA;AAmBF;;AAhBA;EACE,SAAA;AAmBF;;AAhBA;EACE;IACE,aAAA;IACA,qCAAA;EAmBF;AACF","sourcesContent":["@import \"../../assets/variables/fonts.scss\";\n\n.secondary-btn {\n  color: var(--btn-text-color) !important;\n  font-size: 12px !important;\n  font-weight: 500;\n  background-color: var(--btn-background-color) !important;\n  margin: 0 5px;\n  font-family: \"ABBVoice-medium\" !important;\n  border-color: var(--btn-border-color) !important;\n}\n.disabled-btn {\n  color: rgba(31, 31, 31, 0.5) !important;\n  font-size: 12px !important;\n  font-weight: 500;\n  background-color: #dbdbdb !important;\n  margin: 0 5px;\n  font-family: \"ABBVoice-medium\" !important;\n  border-color: #dbdbdb !important;\n}\n\n.secondary-btn:hover {\n  color: #1f1f1f !important;\n  font-size: 12px !important;\n  font-weight: 500;\n  margin: 0 5px;\n  font-family: \"ABBVoice-medium\" !important;\n  border-radius: 16px;\n  border: 2px solid rgba(0, 0, 0, 0.24) !important;\n  background: rgba(0, 0, 0, 0.12) !important;\n}\n.disabled-btn:hover {\n  color: rgba(31, 31, 31, 0.5) !important;\n  font-size: 12px !important;\n  font-weight: 500;\n  background-color: #dbdbdb !important;\n  margin: 0 5px;\n  font-family: \"ABBVoice-medium\" !important;\n  border-color: #dbdbdb !important;\n}\n.btn-submit {\n  background-color: #3366ff;\n  border: 2px solid #3366ff;\n  color: white;\n  cursor: pointer;\n  font-size: 12px;\n  font-family: \"ABBVoice\";\n  border-radius: 16px;\n  height: 32px;\n  padding: 0 16px;\n  margin-top: 0;\n}\n\n.btn-submit:hover {\n  background-color: #2a35ff;\n  border-color: #2a35ff;\n}\n\n.btn-submit:disabled {\n  background-color: #ebebeb;\n  border: 2px solid #dbdbdb;\n  color: rgba(31, 31, 31, 0.5);\n  border-radius: 16px;\n  cursor: not-allowed;\n}\n.ABB_CommonUX_Input__root\n  > .ABB_CommonUX_Input__inputWrapper\n  > .ABB_CommonUX_Input__inputElement {\n  font-size: 12px !important;\n}\nspan.ABB_CommonUX_Button__text.ABB_CommonUX_Button__hasText.ABB_CommonUX_Button__hasIcon {\n  font-size: 12px;\n}\n.ABB_CommonUX_Icon__root > i.ABB_CommonUX_Icon__icon_abb_16 {\n  font-size: 12px;\n}\n.ABB_CommonUX_Icon__root > i {\n  line-height: 1.5;\n}\n.ag-theme-quartz .ag-header-cell {\n  font-size: 12px !important;\n}\n.ag-row {\n  font-size: 12px !important;\n}\ninput[type=\"text\"] {\n  font-size: 12px !important;\n}\n.css-15g569d-control {\n  font-size: 12px !important;\n}\n.css-1xr93k-control,\n.css-1xr93k-control:hover {\n  font-size: 12px !important;\n}\n.ABB_CommonUX_Button__root,\n.ABB_CommonUX_Dropdown__root,\n.ABB_CommonUX_Checkbox__root {\n  font-size: 12px !important;\n  width: 100%;\n}\n.ag-header-cell-text {\n  font-size: 12px !important;\n}\n.jVORrT {\n  height: 14px !important;\n  width: 14px !important;\n}\n.ewTnKk > svg {\n  height: 14px !important;\n  width: 14px !important;\n}\n.sc-gEvEer .ffXrxx {\n  font-size: 12px !important;\n}\n:where(.css-dev-only-do-not-override-m4timi).ant-select-multiple,\n:where(.css-dev-only-do-not-override-m4timi).ant-picker\n  .ant-picker-input\n  > input {\n  font-size: 12px !important;\n}\ninput[type=\"text\"] {\n  padding-block: 0;\n  padding-inline: 10px !important;\n}\n// .page-header {\n//   height: 58px !important;\n//   .inner-header .breadcrumbs {\n//     display: flex;\n//     flex-direction: row;\n//     margin-left: 30px;\n//     align-items: center !important;\n//   }\n// }\n.page-header {\n  height: 58px !important;\n  .inner-header {\n    .app-title {\n      font-family: \"ABBVoice-medium\", sans-serif;\n      display: flex !important;\n      font-size: 16px !important;\n      position: relative !important;\n      padding-left: 0 !important;\n      justify-content: center !important;\n      align-items: center !important;\n      margin-top: 15px !important;\n      margin-left: 15px !important;\n    }\n    .breadcrumbs {\n      font-family: \"ABBVoice-regular\", sans-serif;\n      display: flex;\n      flex-direction: row;\n      margin-left: 30px;\n      align-items: center;\n      margin-top: 16px !important;\n  }\n  }\n} \n.page-header .inner-header .app-title:before {\n  position: absolute;\n    content: \"\";\n    width: 22px !important;\n    height: 3px !important;\n    background-color: #f01;\n    top: -7px !important;\n    left: 0px !important;\n }\n.MuiButtonBase-root.MuiButton-root.secondary {\n  background-color: var(--btn-background-color) !important;\n  color: var(--btn-text-color)!important;\n  border: 1px solid var(--btn-border-color)!important;\n}\n\n.MuiButtonBase-root.MuiButton-root.secondary.disabled {\n  background-color: #dbdbdb !important;\n  color: #9f9f9f;\n  pointer-events: none;\n  cursor: not-allowed !important;\n}\n.ABB_CommonUX_Dialog__root\n  > .ABB_CommonUX_Dialog__header\n  > .ABB_CommonUX_Dialog__title {\n  font-size: 14px !important;\n  font-weight: 600;\n}\n.ABB_CommonUX_Icon__root > i.ABB_CommonUX_Icon__icon_abb_24 {\n  font-size: 16px !important;\n  width: 100% !important;\n  display: flex;\n  align-items: center;\n}\n.jVORrT {\n  display: none !important;\n}\n.jiMOeR {\n  position: relative;\n  height: 40px !important;\n}\n.error-message {\n  color: red;\n  font-size: 14px;\n}\n\n.grid-container {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n}\n.content-container .child-content {\n  width: 100%;\n}\n\n.col-1 {\n  grid-column: span 1;\n}\n\n.col-2 {\n  grid-column: span 2;\n}\n\n.col-3 {\n  grid-column: span 3;\n}\n.col-4 {\n  grid-column: span 4;\n}\n.col-5 {\n  grid-column: span 5;\n}\n.col-6 {\n  grid-column: span 6;\n}\n.col-7 {\n  grid-column: span 7;\n}\n.col-8 {\n  grid-column: span 8;\n}\n.col-9 {\n  grid-column: span 9;\n}\n.col-10 {\n  grid-column: span 10;\n}\n.col-11 {\n  grid-column: span 11;\n}\n.col-12 {\n  grid-column: span 12;\n}\n\n.mr-20 {\n  margin-right: 20px;\n}\n\n.gap-20 {\n  gap: 20px;\n}\n\n@media screen and (max-width: 1200px) {\n  .grid-container {\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
